import { render, staticRenderFns } from "./CategoriesModal.vue?vue&type=template&id=2837ece6&scoped=true"
import script from "./CategoriesModal.vue?vue&type=script&lang=js"
export * from "./CategoriesModal.vue?vue&type=script&lang=js"
import style0 from "./CategoriesModal.vue?vue&type=style&index=0&id=2837ece6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2837ece6",
  null
  
)

export default component.exports